import { createAsyncThunk } from "@reduxjs/toolkit";
import { companyService } from "@/shared/services/api/company-service";
import { ICompanyUpdateRequest } from "@/shared/services/interface/requests/ICompany";

export const updateCompany = createAsyncThunk(
  "company/updateCompany",
  async ({ id, data }: { id: string; data: ICompanyUpdateRequest }, thunkAPI) => {
    try {
      const response = await companyService.updateCompany(id, data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "An error occurred");
    }
  }
);

export const updateCompanyLogo = createAsyncThunk(
  "company/updateCompanyLogo",
  async ({ id, image }: { id: string; image: File }, thunkAPI) => {
    try {
      const response = await companyService.updateCompanyLogo(id, image);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "An error occurred");
    }
  }
); 